<template>
  <div>
    <el-table
      v-loading="loading"
      :data="fusion_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
      stripe
      style="width: 100%;margin-top: 10px;"
      empty-text="No data available in table">
      <el-table-column
        align="center"
        sortable
        fixed
        prop="fusion"
        label="fusion"
        width="300">
        <template slot-scope="scope"> {{ scope.row.fields.fusion }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="cancer"
        label="cancer"
        width="250">
        <template slot-scope="scope"> {{ scope.row.fields.cancer }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sample"
        label="sample"
        width="250">
        <template slot-scope="scope"> {{ scope.row.fields.sample }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="reads"
        label="reads"
        width="120">
        <template slot-scope="scope"> {{ scope.row.fields.reads }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="breakpoint1"
        label="breakpoint1"
        width="300">
        <template slot-scope="scope"> {{ scope.row.fields.breakpoint1 }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="breakpoint2"
        label="breakpoint2"
        width="300">
        <template slot-scope="scope"> {{ scope.row.fields.breakpoint2 }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        fixed="type"
        label="type"
        width="100">
        <template slot-scope="scope"> {{ scope.row.fields.type }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="confidence"
        label="confidence"
        width="140">
        <template slot-scope="scope"> {{ scope.row.fields.confidence }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="source"
        label="source"
        width="137">
        <template slot-scope="scope"> {{ scope.row.fields.source }}</template>
      </el-table-column>
    </el-table>
    <!--    分页操作-->
    <div style="margin-top: 30px;margin-bottom: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="fusion_list.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "browse",
  created: function () {
    this.showFusion()
  },

  data() {
    return {
      fusion_list: [],
      // 分页
      // 默认显示第几页
      currentPage: 1,
      // 个数选择器（可修改）
      pageSizes: [20, 50, 100, 200, 300, 400],
      // 默认每页显示的条数（可修改）
      PageSize: 20,

      loading:true
    }
  },
  methods: {
    showFusion() {
      this.loading=true
      this.$http.get('http://bioinfo-sysu.com:9000/api/show_fusions')
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.fusion_list = res['list']
            this.loading=false
          }
        })
    },
    //分页
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Browse.vue